export const formatEuro = (price?: number | null): string =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(price || 0);
